import React, { useState } from 'react';
import { ReactComponent as MessageOpenIcon } from 'icons/messageOpen.svg';
import { ReactComponent as ArchiveIcon } from 'icons/archive.svg';
import { ReactComponent as DeleteIcon } from 'icons/delete.svg';
import { ReactComponent as TagIcon } from 'icons/tag.svg';
import { Menu, MenuItem, Tooltip, IconButton } from '@material-ui/core';
import { REPLY_STATUS_OPTIONS } from 'constants/outreach';
import { Can } from 'utils/permissions';


const ACTIONS = [
  { label: 'Mark as read', value: 'markAsRead' },
  { label: 'Archive', value: 'archive' },
  { label: 'Delete', value: 'delete' },
];

const moreActions = {
  archive: 'Unarchive',
  markAsRead: 'Mark as unread',
};

export const ACTION_MARK_AS_READ = ACTIONS[0].value;
export const ACTION_ARCHIVE = ACTIONS[1].value;
export const ACTION_DELETE = ACTIONS[2].value;

const ACTION_ICON = {
  [ACTION_MARK_AS_READ]: <MessageOpenIcon />,
  [ACTION_ARCHIVE]: <ArchiveIcon />,
  [ACTION_DELETE]: <DeleteIcon />,
};

const MessageActionIcons = ({
  handleChangeCategory, handleChangeAction, isWhiteGlove, isArchive, isRead, fetchMessages,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const onCategoryClick = (event, option) => {
    event.stopPropagation();
    handleChangeCategory(option);
    setAnchorEl(null);
  };
  const onActionClick = async (event, option) => {
    event.stopPropagation();
    await handleChangeAction(option);
    if (['archive', 'unarchive'].includes(option.value)) {
      fetchMessages({}, true);
    }
  };

  return (
    <>
      {handleChangeCategory &&
        <Can I="changeStatus" a="Message">
          <Tooltip title="Categorize">
            <IconButton onClick={e => setAnchorEl(e.currentTarget)}>
              <TagIcon />
            </IconButton>
          </Tooltip>

          <Menu
            keepMounted
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
          >
            {REPLY_STATUS_OPTIONS.map(opt => (
              <MenuItem onClick={e => onCategoryClick(e, opt)}>{opt.label}</MenuItem>
            ))}
          </Menu>
        </Can>
      }
      {ACTIONS.map((option) => {
        if (option.value === 'archive' && isWhiteGlove) {
          return null;
        } else if (!isWhiteGlove && isArchive && option.value === 'archive') {
          return (
            <Can I={option.value} a="Message">
              <Tooltip title={moreActions[option.value]}>
                <IconButton onClick={e => onActionClick(e, option)}>
                  {ACTION_ICON[option.value]}
                </IconButton>
              </Tooltip>
            </Can>
          );
        } else if (!isWhiteGlove && isRead && option.value === 'markAsRead') {
          return (
            <Can I={option.value} a="Message">
              <Tooltip title={moreActions[option.value]}>
                <IconButton onClick={e => onActionClick(e, option)}>
                  {ACTION_ICON[option.value]}
                </IconButton>
              </Tooltip>
            </Can>
          );
        }
        return (
          <Can I={option.value} a="Message">
            <Tooltip title={option.label}>
              <IconButton onClick={e => onActionClick(e, option)}>
                {ACTION_ICON[option.value]}
              </IconButton>
            </Tooltip>
          </Can>
        );
      })}
    </>
  );
};

export default MessageActionIcons;
